module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 321
// module chunks = 0